import * as React from 'react'

function ArrowLeftIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={16} height={16} fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M10 13.28L5.653 8.933a1.324 1.324 0 010-1.866L10 2.72'
        stroke='#2A8640'
        fill='none'
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default ArrowLeftIcon
